/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocations_NewInputs */

const en_admin_allocations_new = /** @type {(inputs: Admin_Allocations_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Allocation`)
};

const de_admin_allocations_new = /** @type {(inputs: Admin_Allocations_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Zuweisung`)
};

const es_admin_allocations_new = /** @type {(inputs: Admin_Allocations_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva asignación`)
};

const fr_admin_allocations_new = /** @type {(inputs: Admin_Allocations_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle attribution`)
};

/** @type {(inputs: Admin_Allocations_NewInputs) => LocalizedString} */
const it_admin_allocations_new = en_admin_allocations_new;

/** @type {(inputs: Admin_Allocations_NewInputs) => LocalizedString} */
const pt_br2_admin_allocations_new = en_admin_allocations_new;

/** @type {(inputs: Admin_Allocations_NewInputs) => LocalizedString} */
const pl_admin_allocations_new = en_admin_allocations_new;

/** @type {(inputs: Admin_Allocations_NewInputs) => LocalizedString} */
const hu_admin_allocations_new = en_admin_allocations_new;

/** @type {(inputs: Admin_Allocations_NewInputs) => LocalizedString} */
const ro_admin_allocations_new = en_admin_allocations_new;

/**
* | output |
* | --- |
* | "New Allocation" |
*
* @param {Admin_Allocations_NewInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocations_new = /** @type {((inputs?: Admin_Allocations_NewInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocations_NewInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocations_new(inputs)
	if (locale === "de") return de_admin_allocations_new(inputs)
	if (locale === "es") return es_admin_allocations_new(inputs)
	if (locale === "fr") return fr_admin_allocations_new(inputs)
	if (locale === "it") return it_admin_allocations_new(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocations_new(inputs)
	if (locale === "pl") return pl_admin_allocations_new(inputs)
	if (locale === "hu") return hu_admin_allocations_new(inputs)
	return ro_admin_allocations_new(inputs)
});
export { admin_allocations_new as "admin.allocations.new" }